// extracted by mini-css-extract-plugin
module.exports = {"root":"PatientQuestionnaire_root__3qV0z","header":"PatientQuestionnaire_header__38zaX","info":"PatientQuestionnaire_info__2fepe"};